export default __webpack_public_path__ + "static/media/pastry.d7b53eb2.png";